export const structureAreas = [
  {
    id: 'profile',
    titleKey: 'views.structure.functionalities.profile.title',
    descriptionKey: 'views.structure.functionalities.profile.description',
    statusKey: 'views.structure.dashboard.status.comingSoon',
    to: '/structure/profile',
    icon: 'mdi-account-cog-outline',
    disabled: true
  },
  {
    id: 'bracing',
    titleKey: 'views.structure.functionalities.bracing.title',
    descriptionKey: 'views.structure.functionalities.bracing.description',
    statusKey: 'views.structure.dashboard.status.available',
    to: '/structure/bracing',
    icon: 'mdi-crop-square',
    disabled: false
  },
  {
    id: 'bearingWall',
    titleKey: 'views.structure.functionalities.bearingWall.title',
    descriptionKey: 'views.structure.functionalities.bearingWall.description',
    statusKey: 'views.structure.dashboard.status.comingSoon',
    to: '/structure/bearing-wall',
    icon: 'mdi-wall',
    disabled: true
  },
  {
    id: 'separationWall',
    titleKey: 'views.structure.functionalities.separationWall.title',
    descriptionKey: 'views.structure.functionalities.separationWall.description',
    statusKey: 'views.structure.dashboard.status.comingSoon',
    to: '/structure/separation-wall',
    icon: 'mdi-wall',
    disabled: true
  }
];
